/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { Component, OnDestroy, OnInit } from '@angular/core';

import { ConfigService } from './../../core/services/config.service';
import { EditModeService } from './../../core/services/edit-mode.service';
import { LmsBaseAppComponent } from '../../core/component/base-app/lms-base-app.component';
import { LmsMenuService } from './../../core/services/lms-menu.service';
import { LmsModuleService } from './../../core/services/lms-module.service';
import { NotesDataService } from './../../shared/services/note-data.service';
import { PopupService } from '../../core/services/popup.service';
import { RouteChangePopupService } from './../../core/services/route-change-popup.service';
import { UtilService } from './../../core/services/util.service';
import { PermitAll } from '@csx/security';
/**
 * @export
 * @class LmsTerminalNotesComponent
 * @extends {LmsBaseAppComponent}
 * @implements {OnInit}
 */
@Component({
  selector: 'lms-terminal-notes',
  templateUrl: './terminal-notes.component.html',
  styleUrls: ['./terminal-notes.component.scss']
})
@PermitAll()
export class LmsTerminalNotesComponent extends LmsBaseAppComponent implements OnInit, OnDestroy {
  configdata: any;
  blankMessage: any;
  errorMessage: any;
  noteTextParent: string;

  /**
   * Creates an instance of LmsTerminalNotesComponent.
   * @param {NotesDataService} notesDataService
   * @param {ConfigService} configService
   * @param {LmsMenuService} lmsMenuService
   * @param {LmsModuleService} lmsModuleService
   * @param {UtilService} utilService
   * @param {EditModeService} editModeService
   * @param {RouteChangePopupService} routeChangePopupService
   * @param {PopupService} popupService
   * @memberof LmsTerminalNotesComponent
   */
  constructor(private notesDataService: NotesDataService, configService: ConfigService, lmsMenuService: LmsMenuService, lmsModuleService: LmsModuleService, utilService: UtilService,
    editModeService: EditModeService, routeChangePopupService: RouteChangePopupService, popupService: PopupService) {
    super(configService, lmsMenuService, lmsModuleService, utilService, editModeService, routeChangePopupService, popupService);
    this.configdata = this.configService.getConfigData();
    this.service = this.notesDataService;
    this.type = this.configdata.menu.type.terminal;
    this.blankMessage = this.configdata.notesLabel.searchTerminalNotes;
    this.errorMessage = this.configdata.messages.invalidTerminalId;
  }

  /**
   * @memberOf LmsTerminalNotesComponent
   */
  public search() {
    if (!this.isEditMode()) {
      this.selectedTab.mode = 'view';
      this.updateTab(this.selectedTab);
    }
    this.noteTextParent = '';
    this.notesDataService.load(this.selectedTab, 'LWTW', 'S');

    setTimeout(() => {
      if (document.getElementById('autoCompleteTexttopHeader')) {
          const selectBox = <HTMLInputElement>document.getElementById('autoCompleteTexttopHeader');
          if (selectBox) {
              selectBox.select();
          }
      }
  }, 150);
  }

  /**
   * @memberOf LmsTerminalNotesComponent
   */
  ngOnInit() {
    super.init(this.search);
  }

  ngOnDestroy() {
    super.destroy();
  }
}
